type MultiRadioField = {
  required?: boolean;
  minCount?: number | string;
  maxCount?: number | string;
  options?: unknown[];
};

export function countSelectedValues(value: unknown): number {
  if (Array.isArray(value)) return value.length;
  if (typeof value === 'string' && value) return 1;
  return 0;
}

/**
 * minCount, capped so that it can always be reached: the backoffice doesn't prevent a minCount
 * above maxCount or above the number of options, which would otherwise block every participant.
 */
export function getEffectiveMinCount(field: MultiRadioField): number {
  const minCount = Number(field.minCount) || 0;
  const maxCount = Number(field.maxCount) || Infinity;
  const optionCount = field.options ? field.options.length : Infinity;
  return Math.min(minCount, maxCount, optionCount);
}

export function isValidMultiRadio(field: MultiRadioField, value: unknown): boolean {
  const count = countSelectedValues(value);
  const minCount = getEffectiveMinCount(field);

  // maxCount is only enforced while selecting (see MultiRadioField): saved answers above it must still submit
  if (count === 0) return !field.required;
  return !minCount || count >= minCount;
}
